__turbopack_context__.v({
  "container": "LocationSliderSection-module-scss-module__Lbnu0W__container",
  "svgClass": "LocationSliderSection-module-scss-module__Lbnu0W__svgClass",
  "svgWrapper": "LocationSliderSection-module-scss-module__Lbnu0W__svgWrapper",
  "title": "LocationSliderSection-module-scss-module__Lbnu0W__title",
});
